export default __webpack_public_path__ + "static/media/MicroMovie.590788f9.jpg";